<template>
    <div ref="loader" class="mt-2">
        <b-container v-if="ready" class="container-lg">
            <b-row class="pb-2">
                <b-col class="col-7 text-start"> <!-- col 7 fixes the german Servicegruppen to be in one line -->
                    <h5><i class="fa-solid fa-chevron-left" @click="goBack"></i> <i
                        class="fas fa-user-group"></i> {{ $t('Resourcegroups') }}</h5>
                </b-col>
                <b-col class="text-end">
                    <button class="btn btn-light btn-sm rounded" type="button" @click="resetFilter()">
                        <i class="fa-solid fa-arrows-rotate"></i>
                    </button>
                </b-col>
            </b-row>
            <b-list-group class="mt-3">
                <b-list-group-item>
                    <b-button class="w-100" variant="primary" @click="toggleFilterForm()">
                        Filter
                    </b-button>
                    <b-collapse id="status" v-model="toggleFilter">
                        <div class="d-flex w-100 mt-2">
                            <b-form-input v-model="listFilter.filter.name" :placeholder="$t('Name')"></b-form-input>
                        </div>
                        <div class="d-flex w-100 mt-2">
                            <b-form-input v-model="listFilter.filter.description"
                                          :placeholder="$t('description')"></b-form-input>
                        </div>
                        <div class="mt-2">
                            <b-button
                                class="w-100"
                                variant="outline-danger"
                                v-on:click="resetFilter">{{ $t('filter.reset-filter') }}
                            </b-button>
                        </div>
                    </b-collapse>
                </b-list-group-item>
            </b-list-group>

            <b-list-group
                v-for="resourceGroup in resourcegroups"
                v-bind:key="resourceGroup.id"
                class="mt-2">
                <b-list-group-item>
                    <div class="d-flex w-100 justify-content-between">
                        <small class="ms-2 mb-1 col-4"><b>{{ $t('Name') }}</b></small>
                        <small class="text-end">{{ resourceGroup.container.name }}</small>
                    </div>
                    <div class="d-flex w-100 justify-content-between">
                        <small class="ms-2 mb-1 col-4"><b>{{ $t('description') }}</b></small>
                        <small class="text-end">{{ resourceGroup.description }}</small>
                    </div>
                    <small class="mt-2"><b>{{ $t('Resource Summary') }}</b>
                        <div class="badge bg-primary-custom text-white ms-1" @click="toResources(resourceGroup.id)">
                            {{ resourceGroup.resource_count }} <i class="text-white fa-solid fa-eye"></i>
                        </div>
                    </small>
                    <small class="btn-group btn-group-sm btn-group-justified w-100 mt-2">
                        <router-link
                            :to="{name: 'resourcesIndex', query: {resourcegroups: resourceGroup.id, status: 0}}"
                            class="btn btn-primary state-button-small">
                            {{ resourceGroup.statesummary[0] }}
                        </router-link>
                        <router-link
                            :to="{name: 'resourcesIndex', query: {resourcegroups: resourceGroup.id, status: 1}}"
                            class="btn btn-success state-button-small">
                            {{ resourceGroup.statesummary[1] }}
                        </router-link>
                        <router-link
                            :to="{name: 'resourcesIndex', query: {resourcegroups: resourceGroup.id, status: 2}}"
                            class="btn btn-warning state-button-small">
                            {{ resourceGroup.statesummary[2] }}
                        </router-link>
                        <router-link
                            :to="{name: 'resourcesIndex', query: {resourcegroups: resourceGroup.id, status: 3}}"
                            class="btn btn-danger state-button-small">
                            {{ resourceGroup.statesummary[3] }}
                        </router-link>
                    </small>
                    <b-row>
                        <small class="mt-2"><i class=" far fa-clock text-primary me-2"></i><b>{{
                                $t('Reminder time')
                            }}</b>
                            {{ resourceGroup.reminder_time }} {{ $t('minute(s)') }} </small>
                    </b-row>
                    <b-row>
                        <small class="mt-2"><i class="far fa-bell text-danger me-2"></i><b>{{ $t('Deadline') }}</b>
                            {{ resourceGroup.deadline }}</small>
                    </b-row>

                    <b-row class="mt-2">
                        <small v-if="resourceGroup.region_managers.length > 0"><b>{{
                                $t('Region Managers')
                            }}</b></small>
                        <small v-if="resourceGroup.region_managers.length > 0">
                            <ul v-for="region_manager in resourceGroup.region_managers" class="mb-0 ms-2 px-2">
                                <li>
                                    {{ region_manager.username }}
                                </li>
                            </ul>
                        </small>
                        <hr v-if="resourceGroup.mailinglist_region_managers.length > 0" class="border-dashed  my-1"/>
                        <small>
                            <ul v-for="mailinglist in resourceGroup.mailinglist_region_managers"
                                class="mb-0 ms-1 ps-2 list-unstyled">
                                <li v-if="permissions.scmmodule && permissions.scmmodule.mailinglists && permissions.scmmodule.mailinglists.index">

                                    <router-link
                                        :to="{name: 'mailinglistInfo', params: {id: mailinglist.id}}"
                                        class="link-underline link-underline-opacity-0">
                                        <i class="fa-solid fa-envelopes-bulk"></i> {{ mailinglist.name }}
                                    </router-link>
                                </li>
                                <li v-else>
                                    {{ mailinglist.name }}
                                </li>
                            </ul>
                        </small>
                    </b-row>
                    <b-row class="mt-2">
                        <small v-if="resourceGroup.managers.length > 0"><b>{{ $t('Managers') }}</b></small>
                        <small v-if="resourceGroup.managers.length > 0">
                            <ul v-for="manager in resourceGroup.managers"
                                class="mb-0 ms-2 px-2">
                                <li>
                                    {{ manager.username }}
                                </li>
                            </ul>
                        </small>
                        <hr v-if="resourceGroup.mailinglist_managers.length > 0" class="border-dashed  my-1"/>
                        <small>
                            <ul v-for="mailinglist in resourceGroup.mailinglist_managers"
                                class="mb-0 ms-1 ps-2 list-unstyled">
                                <li v-if="permissions.scmmodule && permissions.scmmodule.mailinglists && permissions.scmmodule.mailinglists.index">
                                    <router-link
                                        :to="{name: 'mailinglistInfo', params: {id: mailinglist.id}}"
                                        class="link-underline link-underline-opacity-0">
                                        <i class="fa-solid fa-envelopes-bulk"></i> {{ mailinglist.name }}
                                    </router-link>
                                </li>
                                <li v-else>
                                    {{ mailinglist.name }}
                                </li>
                            </ul>
                        </small>
                    </b-row>
                    <b-row class="mt-2">
                        <small v-if="resourceGroup.users.length > 0"><b>{{ $t('Users') }}</b></small>
                        <small v-if="resourceGroup.users.length > 0">
                            <ul v-for="user in resourceGroup.users"
                                class="mb-0 ms-2 px-2">
                                <li>
                                    {{ user.username }}
                                </li>
                            </ul>
                        </small>
                        <hr v-if="resourceGroup.mailinglist_users.length > 0" class="border-dashed  my-1"/>
                        <small>
                            <ul v-for="mailinglist in resourceGroup.mailinglist_users"
                                class="mb-0 ms-1 ps-2 list-unstyled">
                                <li v-if="permissions.scmmodule && permissions.scmmodule.mailinglists && permissions.scmmodule.mailinglists.index">
                                    <router-link
                                        :to="{name: 'mailinglistInfo', params: {id: mailinglist.id}}"
                                        class="link-underline link-underline-opacity-0">
                                        <i class="fa-solid fa-envelopes-bulk"></i> {{ mailinglist.name }}
                                    </router-link>
                                </li>
                                <li v-else>
                                    {{ mailinglist.name }}
                                </li>
                            </ul>
                        </small>
                    </b-row>
                </b-list-group-item>
            </b-list-group>
            <b-list-group ref="noMass" class="mt-3">
                <div v-if="resourcegroups.length > 0">
                    <div class="d-flex w-100 justify-content-between">
                        <small>{{ $t('page') }} {{ paging.page }}</small>
                        <small>{{ $t('pagesize') }} {{ paging.limit }}</small>
                    </div>
                    <div class="d-flex w-100 justify-content-center mt-4">
                        <vue-awesome-paginate
                            v-model="paging.page"
                            :items-per-page="25"
                            :max-pages-shown="5"
                            :total-items="paging.count"
                            @click="getData"
                        />
                    </div>
                </div>
                <b-list-group-item v-if="resourcegroups.length === 0">
                    <h5 class="mb-1">{{ $t('noitems') }}</h5>
                </b-list-group-item>
            </b-list-group>

        </b-container>
    </div>
</template>
<script>
import { BFormCheckbox } from 'bootstrap-vue-next';
import { VueAwesomePaginate } from "vue-awesome-paginate";
import Multiselect from "vue-multiselect";
import { useToast } from 'vue-toastification';
import { debounce } from "../helpers";

export default {
    name: "ResourcegroupsIndex",
    components: {BFormCheckbox, VueAwesomePaginate, Multiselect},
    data() {
        return {
            ready: false,
            listFilter: {
                filter: {
                    id: [],
                    name: '',
                    description: '',
                }
            },
            paging: {
                page: 1,
                pageCount: 1,
                count: 1
            },
            resourcegroups: [],
            settings: [],
            error: {
                status: false,
                comment: false
            },
            permissions: {},
            toggleFilter: false
        }
    },
    mounted() {
        this.permissions = this.$store.state.permissions;

        if(this.$route.query.resourcegroups) {
            if(Array.isArray(this.$route.query.resourcegroups)) {
                this.listFilter.filter.id = this.$route.query.resourcegroups;
            } else {
                this.listFilter.filter.id = [this.$route.query.resourcegroups];
            }
        }
        //this.getData();

    },
    methods: {
        getData: function() {
            let loader = this.$loading.show();
            axios.post('/resourcegroups/index.json', {
                    filter: this.listFilter,
                    page: this.paging.page
                },
                {}
            ).then(result => {
                this.resourcegroups = result.data.response.all_resourcegroups ?? [];
                this.paging = result.data.response.paging ?? {
                    page: 1,
                    pageCount: 1
                };
                this.ready = true;
            }).catch(error => {
                console.log(error)
            }).finally(() => {
                loader.hide();
            });
        },
        toResources: function(resourcegroup) {
            if(resourcegroup.length === 0) {
                return;
            }
            this.$router.push({name: 'resourcesIndex', query: {resourcegroups: resourcegroup}});
        },
        goBack: function() {
            this.$router.push({name: 'dashboardsIndex'});
        },
        toggleFilterForm: function() {
            this.toggleFilter = !this.toggleFilter;
        },
        resetFilter: function() {
            this.listFilter.filter =
                {
                    id: [],
                    name: '',
                    description: '',
                };
            this.paging.page = 1;

        }

    },
    watch: {
        'listFilter.filter': {
        handler:
            debounce(function() {
                //if(this.ready) {
                    this.paging.page = 1;
                    this.getData();
                //}
            }, 500),

                deep: true
        }
    }

}
</script>


<style scoped>
div.required .control-label::after {
    content: ' *';
    color: red;
    display: inline;
}

hr.border-dashed {
    border-style: dashed;
}

.list-unstyled {
    padding-left: 0;
    list-style: none;
}


</style>